export const CONSENT_VERSION = 'alvi-2026-10-02';
export const POLICY_URL = 'https://alvi-clinic.ru/privacy-new';
export const CONSENT_URL = 'https://alvi-clinic.ru/soglasie';
export const consentPayload = (accepted) => ({
  consent_accepted: accepted === true,
  consent_version: CONSENT_VERSION,
});